export default __webpack_public_path__ + "static/media/instagram.9f88045f.svg";